import { render, staticRenderFns } from "./SolicitarLaudo.vue?vue&type=template&id=f9077dda&scoped=true&lang=pug"
import script from "./SolicitarLaudo.vue?vue&type=script&lang=js"
export * from "./SolicitarLaudo.vue?vue&type=script&lang=js"
import style0 from "./SolicitarLaudo.vue?vue&type=style&index=0&id=f9077dda&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9077dda",
  null
  
)

export default component.exports